import { CspDirectives } from '@phoenix/core/frontend/shared/domain/security/csp.model';

const appDomains = process.env.NEXT_PUBLIC_APP_DOMAINS;
const googleMapsDomains = ['https://maps.googleapis.com', 'https://maps.gstatic.com'].join(' ');
const fontDomains = ['data:', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].join(' ');

export const imageDomains = [
  'https://images.ctfassets.net',
  'https://www.stihl.de ',
  'https://static.stihl.com',
  'https://datastorcproductsint.blob.core.windows.net',
  'https://datastorcproductsprd.blob.core.windows.net',
  'https://dam.stihl.cloud',
  'blob:',
];

export const iovation = {
  connect: 'wss://mpsnare.iesnare.com/star',
  script: 'https://mpsnare.iesnare.com',
  media: 'data: https://mpsnare.iesnare.com',
};

export const toolShedCspDirectives: CspDirectives = {
  connectSrc: `${googleMapsDomains} ${appDomains} https://cdn.contentful.com ${iovation.connect}`,
  imgSrc: `data: ${imageDomains.join(' ')} ${googleMapsDomains}`,
  scriptSrc: `${googleMapsDomains} ${iovation.script}`,
  styleSrc: fontDomains,
  fontSrc: fontDomains,
  mediaSrc: iovation.media,
};
